import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { getSingleSparePart, updateSingleSparePart } from '../../actions'

const SparePartsUpdate = () => {
    const {spUpdate} = useParams()
    const [spareParts, setSpareParts] = useState({
        // sparePartOwnerName:'',
        // about:'',
        // mobileNumberCountryCode:'',
        // mobileNumber:'',
        // location:'',
        // whatsAppNumber:'',
        // whatsAppNumberCountryCode:'',
        status: '',
        subscriptionExpiry: '',
    })
    const [businessMedia, setBusinessMedia] = useState([])

    // console.log("spUpdate", spareParts);

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getSingleSparePart(spUpdate))
    },[])

    const sparePartData = useSelector(state => state.home.singleSparePart)

    const data = sparePartData?.response?.data?.[0]
    

    useEffect(() => {
        setSpareParts({
            // sparePartOwnerName:data?.sparePartOwnerName,
            // about:data?.about,
            // mobileNumberCountryCode:data?.mobileNumberCountryCode,
            // mobileNumber:data?.mobileNumber,
            // location:data?.location,
            // whatsAppNumber:data?.whatsAppNumber,
            // whatsAppNumberCountryCode:data?.whatsAppNumberCountryCode,
            status: data?.status,
			subscriptionExpiry: data?.currentSubscription?.expiry?.split('T')[0] || '', 
        })
    },[data, spUpdate])

    // console.log("datasdasdasda", data);

    const onChangeHandle = (e) => {
        const {name, value} = e.target
        setSpareParts({...spareParts,[name]:value})
    }

    const uploadMedia = (e) => {}
    const onCLickHandle = () => {
        if(data!==null){
            const updatedData = {
                businessId: spUpdate,
                status: spareParts?.status,
            }

            if (spareParts.subscriptionExpiry) {
                try {
                    updatedData.subscriptionExpiry = new Date(spareParts.subscriptionExpiry).toISOString();
                } catch (e) {
                    console.error("Invalid subscriptionExpiry:", spareParts.subscriptionExpiry);
                }
            }            
            dispatch(updateSingleSparePart(updatedData));
        }
    }

  return (
    <div className='main-body'>
            <div className='page-wrapper'>
                <div className='page-header'>
                    <div className='row align-items-end'>
                        <div className='col-lg-8'>
                            <div className='page-header-title'>
                                <div className='d-inline'>
                                    <h4>
                                        Edit : {data?.sparePartOwnerName}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='page-header-breadcrumb'>
                                <ul className='breadcrumb-title'>
                                    <li className='breadcrumb-item'>
                                        <Link to='/'>
                                            <i className='feather icon-home'></i>{' '}
                                        </Link>
                                    </li>
                                    <li className='breadcrumb-item'>
                                        <Link to='/ServiceProviders/SpareParts'>Spare Parts List</Link>
                                    </li>
                                    <li className='breadcrumb-item active'>
                                        Edit Garage
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='page-body'>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className='card card-border-default'>
                                <div className='card-block'>
                                    <div className='tab-content tabs'>
                                        <div
                                            className='tab-pane  active'
                                            id={'car_user_'}
                                            role='tabpanel'
                                            aria-labelledby=''>
                                                <div className=''>
                                                    <div className='card-body'>
                                                        <div className='row'>
                                                            {/* <div className='col-md-6'>
                                                                <div className='form-group row'>
                                                                    <label className='col-sm-3 col-form-label'>Owner Name</label>
                                                                    <div className='col-sm-9'>
                                                                        <input
                                                                            type='text'
                                                                            className='form-control'
                                                                            name='sparePartOwnerName'
                                                                            value={spareParts.sparePartOwnerName}
                                                                            placeholder='Garage Name'
                                                                            onChange={onChangeHandle}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div> */}

                                                            {/* <div className='col-md-6'>
                                                                <div className='form-group row'>
                                                                    <label className='col-sm-3 col-form-label'>About</label>
                                                                    <div className='col-sm-9'>
                                                                       <input type="text" name="about" onChange={onChangeHandle} className='form-control' value={spareParts.about}  placeholder='About' />
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                                
                                                            {/* <div className='col-md-6'>
                                                                <div className='form-group row'>
                                                                    <label className='col-sm-3 col-form-label'>Country Code</label>
                                                                    <div className='col-sm-9'>
                                                                        <select name="mobileNumberCountryCode" className='form-control' value={spareParts.mobileNumberCountryCode} onChange={onChangeHandle}>
                                                                            <option value="">Select County Code</option>
                                                                            <option value="+965">+965</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                            {/* <div className='col-md-6'>
                                                                <div className='form-group row'>
                                                                    <label className='col-sm-3 col-form-label'>Phone Number</label>
                                                                    <div className='col-sm-9'>
                                                                        <input
                                                                            type='number'
                                                                            className='form-control'
                                                                            name='mobileNumber'
                                                                            value={spareParts.mobileNumber}
                                                                            placeholder='Phone Number'
                                                                            onChange={onChangeHandle}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                            {/* <div className='col-md-6'>
                                                                <div className='form-group row'>
                                                                    <label className='col-sm-3 col-form-label'>Location</label>
                                                                    <div className='col-sm-9'>
                                                                        <input
                                                                            type='text'
                                                                            className='form-control'
                                                                            name='location'
                                                                            value={spareParts.location}
                                                                            placeholder='Enter Location'
                                                                            onChange={onChangeHandle}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                            {/* <div className='col-md-6'>
                                                                <div className='form-group row'>
                                                                    <label className='col-sm-3 col-form-label'>Country Code (WhatsApp)</label>
                                                                    <div className='col-sm-9'>
                                                                        <select name="whatsAppNumberCountryCode" className='form-control' value={spareParts.whatsAppNumberCountryCode} onChange={onChangeHandle}>
                                                                            <option value="">Select County Code</option>
                                                                            <option value="+965">+965</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                            {/* <div className='col-md-6'>
                                                                <div className='form-group row'>
                                                                    <label className='col-sm-3 col-form-label'>Phone Number (WhatsApp)</label>
                                                                    <div className='col-sm-9'>
                                                                        <input
                                                                            type='number'
                                                                            className='form-control'
                                                                            name='whatsAppNumber'
                                                                            value={spareParts.whatsAppNumber}
                                                                            placeholder='Phone Number'
                                                                            onChange={onChangeHandle}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                            {/* <div className='col-md-6'>
                                                        <div className='row'>
                                                            <div className='col-sm-3'> Image</div>
                                                            <div className='col-sm-9'>
                                                                <form
                                                                    id='userImage'
                                                                    name='userImage'
                                                                    encType='multipart/form-data'
                                                                    className='text-capitalize'>
                                                                    <div className='form-group'>
                                                                        <input
                                                                            accept='image/*'
                                                                            onChange={uploadMedia}
                                                                            id='banner_image'
                                                                            type='file'
                                                                            className='form-control'
                                                                            autoComplete='off'
                                                                            name='media'
                                                                            data-toggle='tooltip'
                                                                            title='Click To Upload Photo'
                                                                        />
                                                                        <div id='banner_image_lable' className='pt-2'>
                                                                                <img
                                                                                    src={}
                                                                                    alt=''
                                                                                    className='img-100'
                                                                                    onError={e => {
                                                                                        e.target.src = '';
                                                                                    }}
                                                                                />

                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    <div className='col-md-6'>
																<div className='form-group row'>
																	<label className='col-sm-3 col-form-label'>Status</label>
																	<div className='col-sm-9'>
																	<select
																		className='form-control'
																		name='status'
																		value={spareParts.status}
																		onChange={onChangeHandle}
																	>
																		<option value='active'>Active</option>
																		<option value='in-active'>Inactive</option>
																	</select>
																	</div>
																</div>
																</div>
																<div className='col-md-6'>
																<div className='form-group row'>
																	<label className='col-sm-3 col-form-label'>Membership Expiry</label>
																	<div className='col-sm-9'>
																	<input
																		type='date'
																		className='form-control'
																		name='subscriptionExpiry'
																		value={spareParts.subscriptionExpiry}
                                                                        disabled={!spareParts.subscriptionExpiry}
																		onChange={onChangeHandle}
																	/>
																	</div>
																</div>
																</div>
                                                </div>
                                                <div className='card-footer'>
                                                    <div className='row float-right p-3'>
                                                        
                                                        <button
                                                            onClick={onCLickHandle}
                                                            className='btn btn-grd-disabled mr-2'>
                                                            <i className='icofont icofont-save'></i> Update
                                                        </button>
                                                        <Link to={'/ServiceProviders/SpareParts'} className='btn btn-outline-dark'>
                                                            
                                                            Cancel
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default SparePartsUpdate